import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import moment from "moment/moment";
import FolderIcon from '../../images/folder.svg';
import MenuIcon from '../../images/menu.svg';
import folders from "../../services/api/folders";
import {GlobalContext} from "../../context/GlobalState";

const Folder = ({folder, goBack}) => {
  const {openMoveModal} = useContext(GlobalContext);
  const deleteFolder = async id => {
    try {
      await folders.delete(id);
      // TODO: Notify better that this was successful (message queue would be cool like Toast)
      window.location.reload();
    } catch (e) {
      // TODO: Show error
    }
  };

  const promptDelete = async () => {
    const shouldDelete = window.confirm('Are you sure you want to delete this folder and all notes and folders inside of it?');

    if (shouldDelete) {
      await deleteFolder(folder.id);
    }
  };

  const goToFolder = () => {
    window.location.href = `/${folder.id}`;
  };

  if (!goBack) {
    return (
      <a onClick={goToFolder} className='row'>
        <div className='folder-name'>
          <div className="icon-container">
            <img src={FolderIcon} alt="folder" />
          </div>
          <p>{folder.name}</p>
        </div>
        <div className="note-count">
          <p>{folder.noteCount && folder.noteCount === 1 ? `${folder.noteCount} note` : `${folder.noteCount || 0} notes`}</p>
        </div>
        <div className="modified">
          <p>{moment(folder.updatedAt).format('MM/DD/YYYY h:mm a')}</p>
        </div>
        <div className="members">
          <p>{`${(folder.sharedWith && folder.sharedWith.length) || 1} member${folder.sharedWith.length !== 0 ? 's' : ''}`}</p>
        </div>
        <div className="menu-button-container">
          <div className="menu-button"
               onClick={e => {
                 e.target.focus();
                 e.stopPropagation();
                 e.nativeEvent.stopImmediatePropagation()
               }}
               tabIndex="0"
          >
            <img src={MenuIcon} alt="menu" />
            <div className="menu">
              <ul>
                <li onClick={promptDelete}>Delete</li>
                <li onClick={() => openMoveModal(folder, 'folder')}>Move</li>
              </ul>
            </div>
          </div>
        </div>
      </a>
    );
  } else {
    return (
      <Link to={`/${folder !== 'home' ? folder : ''}`} className='row' style={{opacity: .6}}>
        <div className='folder-name'>
          <div className="icon-container">
            <img src={FolderIcon} alt="folder" />
          </div>
          <p style={{fontWeight: 'bold'}}>..</p>
        </div>
      </Link>
    )
  }
};

export default Folder;
